import {
  UserChallengeRank,
  TeamChallengeRank,
} from '@leagueplatform/health-journey-api';

export const isTeamRank = (
  data: TeamChallengeRank | UserChallengeRank,
): data is TeamChallengeRank =>
  (data as TeamChallengeRank).teamName !== undefined;
